import { useCartSummary } from "@design-lab/features/manage-cart";
import { useIsSample } from "@design-lab/shared/lib/config";
import { DeliveryDateText } from "./DeliveryDateText";
import { type DeliveryDateInfo } from "../model/HeaderModes";

function TruckIcon() {
  return (
    <svg
      className="shrink-0"
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19.1803" cy="19.4899" r="19.1803" fill="var(--default-blue-600)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.597 8.32323C18.8629 8.26856 19.137 8.26856 19.4028 8.32323C19.7101 8.38643 19.9848 8.54025 20.2031 8.66255C20.2234 8.67394 20.2433 8.68505 20.2626 8.69579L19.7845 9.55642L20.2626 8.69579L27.6626 12.8069C27.6831 12.8183 27.7041 12.8299 27.7257 12.8418C27.9569 12.9691 28.2475 13.1292 28.4707 13.3713L28.1562 13.6611L28.4707 13.3713C28.6636 13.5807 28.8096 13.8289 28.899 14.0992C29.0023 14.4119 29.0011 14.7437 29.0001 15.0076C29 15.0322 28.9999 15.0563 28.9999 15.0797L28.9999 19.6383C28.9999 20.1906 28.5522 20.6383 27.9999 20.6383C27.4477 20.6383 26.9999 20.1906 26.9999 19.6383L26.9999 15.8377L24.0028 17.5028C23.992 17.5091 23.981 17.5152 23.97 17.521L19.9999 19.7266L19.9999 27.4388L20.5143 27.153C20.9971 26.8848 21.6059 27.0587 21.8741 27.5415C22.1423 28.0243 21.9684 28.6331 21.4856 28.9013L20.2626 29.5807C20.2433 29.5915 20.2234 29.6026 20.2031 29.614C19.9848 29.7363 19.7101 29.8901 19.4028 29.9533C19.137 30.008 18.8629 30.008 18.5971 29.9533C18.2898 29.8901 18.0151 29.7363 17.7968 29.614C17.7765 29.6026 17.7566 29.5915 17.7373 29.5807L10.3373 25.4696C10.3168 25.4583 10.2957 25.4467 10.2741 25.4348C10.043 25.3075 9.75238 25.1474 9.52921 24.9052C9.33626 24.6958 9.19024 24.4477 9.10091 24.1773C8.99759 23.8646 8.9988 23.5328 8.99976 23.269C8.99985 23.2443 8.99994 23.2202 8.99994 23.1968V15.0797C8.99994 15.0563 8.99985 15.0322 8.99976 15.0076C8.9988 14.7437 8.99759 14.4119 9.10091 14.0992C9.19024 13.8289 9.33626 13.5807 9.52921 13.3713C9.75238 13.1292 10.043 12.9691 10.2741 12.8418C10.2957 12.8299 10.3168 12.8183 10.3373 12.8069L10.3373 12.8069L13.999 10.7726C14.0086 10.7671 14.0182 10.7617 14.028 10.7565L17.7373 8.69579C17.7566 8.68505 17.7764 8.67394 17.7968 8.66255C18.0151 8.54026 18.2898 8.38643 18.597 8.32323ZM14.4999 12.7822L12.0591 14.1383L18.9999 17.9943L21.4408 16.6382L14.4999 12.7822ZM23.4999 15.4943L16.5591 11.6383L18.7086 10.4441C18.8601 10.3599 18.9375 10.3174 18.9952 10.2895C18.9968 10.2887 18.9984 10.288 18.9999 10.2873C19.0015 10.288 19.0031 10.2887 19.0047 10.2895C19.0624 10.3174 19.1398 10.3599 19.2913 10.4441L25.9408 14.1382L23.4999 15.4943ZM17.9999 19.7266L10.9999 15.8378V23.1968C10.9999 23.3798 11.0004 23.4735 11.0044 23.5413C11.0046 23.5433 11.0047 23.5452 11.0048 23.547C11.0063 23.548 11.008 23.549 11.0096 23.5501C11.0669 23.5866 11.1486 23.6325 11.3086 23.7213L10.8229 24.5955L11.3086 23.7213L17.9999 27.4388L17.9999 19.7266ZM29.707 22.4312C30.0976 22.8217 30.0976 23.4549 29.707 23.8454L25.707 27.8454C25.3165 28.2359 24.6834 28.2359 24.2928 27.8454L22.2928 25.8454C21.9023 25.4548 21.9023 24.8217 22.2928 24.4312C22.6834 24.0406 23.3165 24.0406 23.707 24.4312L24.9999 25.7241L28.2928 22.4312C28.6834 22.0406 29.3165 22.0406 29.707 22.4312Z"
        fill="white"
      />
    </svg>
  );
}

function FeesIcon() {
  return (
    <div className="bg-default-blue-600 flex h-10 w-10 shrink-0 flex-row items-center justify-center rounded-full">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4841_2850)">
          <path d="M21.0195 15.8691H23.2474V17.3446H21.0195V15.8691Z" fill="white" />
          <path
            d="M20.0781 20.6562L20.5812 19.2694L22.6685 20.0266L22.1654 21.4134L20.0781 20.6562Z"
            fill="white"
          />
          <path
            d="M20.082 12.5547L22.1693 11.7975L22.6724 13.1844L20.5851 13.9416L20.082 12.5547Z"
            fill="white"
          />
          <path d="M1.11523 15.8691H3.3431V17.3446H1.11523V15.8691Z" fill="white" />
          <path
            d="M1.68945 20.041L3.77613 19.2818L4.28058 20.6683L2.1939 21.4275L1.68945 20.041Z"
            fill="white"
          />
          <path
            d="M1.67773 13.1758L2.18085 11.7889L4.26811 12.5461L3.765 13.933L1.67773 13.1758Z"
            fill="white"
          />
          <path
            d="M12.1804 9.96875C10.8672 9.96875 9.58357 10.3581 8.49174 11.0877C7.39991 11.8172 6.54892 12.8541 6.04641 14.0673C5.54389 15.2805 5.41241 16.6155 5.66859 17.9034C5.92477 19.1913 6.55711 20.3743 7.48564 21.3028C8.41417 22.2313 9.59718 22.8637 10.8851 23.1199C12.173 23.376 13.5079 23.2446 14.7211 22.742C15.9343 22.2395 16.9712 21.3885 17.7008 20.2967C18.4303 19.2049 18.8197 17.9212 18.8197 16.6081C18.8197 14.8472 18.1202 13.1585 16.8751 11.9134C15.63 10.6683 13.9412 9.96875 12.1804 9.96875ZM14.7623 14.8892H11.5681C11.4986 14.8807 11.4281 14.887 11.3613 14.9078C11.2944 14.9285 11.2327 14.9632 11.1803 15.0096C11.1279 15.056 11.0859 15.113 11.0572 15.1768C11.0284 15.2406 11.0135 15.3098 11.0135 15.3798C11.0135 15.4498 11.0284 15.519 11.0572 15.5828C11.0859 15.6466 11.1279 15.7036 11.1803 15.75C11.2327 15.7964 11.2944 15.8311 11.3613 15.8519C11.4281 15.8726 11.4986 15.8789 11.5681 15.8704H12.7927C13.0504 15.8622 13.3071 15.9048 13.5484 15.9958C13.7896 16.0868 14.0105 16.2244 14.1986 16.4008C14.3866 16.5772 14.5381 16.7889 14.6443 17.0238C14.7505 17.2587 14.8094 17.5123 14.8177 17.77C14.8259 18.0277 14.7833 18.2845 14.6923 18.5257C14.6013 18.7669 14.4636 18.9879 14.2873 19.1759C14.1109 19.3639 13.8992 19.5154 13.6642 19.6216C13.4293 19.7278 13.1758 19.7867 12.9181 19.795V21.0343H11.4427V19.8024H9.5984V18.3269H12.7927C12.8621 18.3355 12.9326 18.3292 12.9995 18.3084C13.0663 18.2877 13.128 18.2529 13.1804 18.2066C13.2328 18.1602 13.2748 18.1032 13.3036 18.0394C13.3323 17.9756 13.3472 17.9064 13.3472 17.8364C13.3472 17.7664 13.3323 17.6972 13.3036 17.6334C13.2748 17.5695 13.2328 17.5126 13.1804 17.4662C13.128 17.4198 13.0663 17.3851 12.9995 17.3643C12.9326 17.3436 12.8621 17.3373 12.7927 17.3458H11.5681C11.0476 17.3624 10.5419 17.1716 10.1621 16.8154C9.78239 16.4592 9.5597 15.9666 9.54307 15.4462C9.52644 14.9258 9.71723 14.4201 10.0735 14.0403C10.4297 13.6605 10.9222 13.4378 11.4427 13.4212V12.1819H12.9181V13.4138H14.7623V14.8892Z"
            fill="white"
          />
          <path
            d="M19.9265 1.11523H4.43468C3.82355 1.11523 3.32812 1.61066 3.32812 2.22179V2.9595C3.32812 3.57063 3.82355 4.06605 4.43468 4.06605H19.9265C20.5376 4.06605 21.033 3.57063 21.033 2.9595V2.22179C21.033 1.61066 20.5376 1.11523 19.9265 1.11523Z"
            fill="white"
          />
          <path
            d="M9.22896 9.05249V5.54102H4.80273V9.91561C4.80352 10.2661 4.88753 10.6114 5.04784 10.923C5.20816 11.2347 5.4402 11.5038 5.72487 11.7082C6.62868 10.5198 7.84048 9.60141 9.22896 9.05249Z"
            fill="white"
          />
          <path
            d="M15.1309 9.05249C16.5193 9.60141 17.7311 10.5198 18.635 11.7082C18.9196 11.5038 19.1517 11.2347 19.312 10.923C19.4723 10.6114 19.5563 10.2661 19.5571 9.91561V5.54102H15.1309V9.05249Z"
            fill="white"
          />
          <path
            d="M13.6559 8.632V5.54102H10.7051V8.632C11.6798 8.44509 12.6812 8.44509 13.6559 8.632Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4841_2850">
            <rect
              width="23.6066"
              height="23.6066"
              fill="white"
              transform="translate(0.376953 0.376953)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function HandshakeIcon() {
  return (
    <div className="bg-default-blue-600 flex size-10 shrink-0 flex-row items-center justify-center rounded-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m11 17 2 2a1 1 0 1 0 3-3" />
        <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
        <path d="m21 3 1 11h-2" />
        <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
        <path d="M3 4h8" />
      </svg>
    </div>
  );
}

export type DeliveryInfoProps = {
  deliveryDateInfo: DeliveryDateInfo;
};

export function DeliveryInfo(props: DeliveryInfoProps) {
  const { deliveryDateInfo } = props;
  const { freeShippingThreshold, isFreeShippingThresholdZero } = useCartSummary();
  const isSample = useIsSample();
  return (
    <div className="flex flex-row items-center gap-8">
      <div className="flex flex-row items-center gap-2">
        <TruckIcon />

        <DeliveryDateText deliveryDateInfo={deliveryDateInfo}>
          {({ valueElement, timeRange, formattedTimeLeft }) => (
            <div>
              <div className="text-lg font-medium text-neutral-950">
                Get it&nbsp;
                <span className="text-default-blue-600 font-bold uppercase">
                  {valueElement}
                </span>{" "}
                {timeRange && formattedTimeLeft && (
                  <span className="font-poppins text-sm font-medium">
                    Order by {formattedTimeLeft}
                  </span>
                )}
              </div>
              <div className="text-sm font-medium text-neutral-950">
                <span className="text-default-blue-600 font-bold">
                  {isSample ? "FAST DELIVERY" : "FREE SHIPPING"}
                </span>
                {!isSample && !isFreeShippingThresholdZero && (
                  <>&nbsp;When you spend ${freeShippingThreshold.toFixed(2)}</>
                )}
              </div>
            </div>
          )}
        </DeliveryDateText>
      </div>

      <div className="flex flex-row items-center gap-2">
        <FeesIcon />

        <div className="text-default-blue-600 text-lg font-bold uppercase">
          No SNEAKY rush fees!
        </div>
      </div>

      <div className="flex flex-row items-center gap-2">
        <HandshakeIcon />

        <a className="flex flex-col" data-testid="bulk-order-cta" href="/wholesale-inquiry">
          <span className="text-default-blue-600 text-sm font-semibold">Larger Order?</span>
          <span className="text-xs font-medium text-gray-600">Click here for help</span>
        </a>
      </div>
    </div>
  );
}
